export type State = {
    isManuallySelected: boolean
    selectedDataRegion: string
    defaultRegion: string
}

export const state: State = {
    isManuallySelected: false,
    selectedDataRegion: "",
    defaultRegion: "",
}
